// src/modules/productos/composables/marcaVehiculoComposables/useMarcaVehiculosList.ts

import { computed } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { ListMarcaModeloVehiculoAction } from "../../actions/marcaVehiculosActions";

export function useMarcaModeloList() {
  const queryClient = useQueryClient();

  // TanStack Query principal
  const query = useQuery({
    queryKey: ["MarcaModeloList"],
    queryFn: () => ListMarcaModeloVehiculoAction(),
    staleTime: 60 * 1000, // cache de 1 min
  });

  // Extraer datos de forma segura
  const marcas = computed(() => {
    // 🔥 Evita errores si la estructura de data cambia o es undefined
    const data = query.data.value;
    return data?.data?.data.marcasVehiculos ?? [];
  });

  return {
    ...query,
    marcas,
  };
}
